import { OreInput, OreMessageBar, OreStack, OreSwitch } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { LoginTranslation } from '@/Account/ui/accountTranslation'
import { LoginForm } from '@/Account/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'
import { useEffect, useState } from 'react'

interface LoginBasicFormProps {
  isBlocked: boolean;
}

export const LoginBasicForm = ({ isBlocked }: LoginBasicFormProps): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } =
    useFormContext<LoginForm>()
  const { errors } = handleErrors(formState)

  const [isFormBlocked, setIsFormBlocked] = useState<boolean>(isBlocked)

  useEffect(() => {
    setIsFormBlocked(isBlocked)
  }, [isBlocked])

  return (
    <OreStack direction="column" space="small" placeContent="stretch">
      <OreInput
        {...register('username')}
        {...errors('username')}
        id="username"
        label={t(LoginTranslation.form.data.user.label)}
        placeholder={t(LoginTranslation.form.data.user.placeholder)}
        legend={t(LoginTranslation.form.data.user.legend)}
        required
        maxLength={75}
        disabled={isFormBlocked}
      />
      <OreInput
        {...register('password')}
        {...errors('password')}
        id="password"
        label={t(LoginTranslation.form.data.password.label)}
        type="password"
        placeholder={t(LoginTranslation.form.data.password.placeholder)}
        required
        disabled={isFormBlocked}
      />
      <OreSwitch
        {...register('rememberUser')}
        label={t(LoginTranslation.form.rememberUser)}
        name="rememberUser"
        disabled={isFormBlocked}
      />
      {formState.errors.root && (
        <OreMessageBar>
          {formState.errors.root.message}
        </OreMessageBar>
      )
      }

    </OreStack>
  )
}
